import { GetPayUpsResponseType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const usePayUps = (tripId: string | undefined) => {
    return useQuery<GetPayUpsResponseType>({
        queryKey: queryKeys.payups(tripId),
        queryFn: async () => {
            if (!tripId) {
                throw new Error('Trip ID is required')
            }
            const response = await api.get<GetPayUpsResponseType>(`/trips/${tripId}/payUps`)
            return response.data
        },
        enabled: !!tripId,
        retry: 1,
    })
}
